import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUserTypeRequest, CreateUserTypeRequestPayload } from 'Services/Api/_HumanWritten/UserTypeRequestService';
import alertToast from 'Util/ToastifyUtils';
import { userTypeRequestKeys } from './userTypeRequestKeys';

export const useCreateUserTypeRequest = (userId?: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (payload: CreateUserTypeRequestPayload) => createUserTypeRequest(payload),
		onSuccess: result => {
			if (result.alreadyPending) {
				alertToast('A request for this account type is already pending', 'info');
			} else if (result.receiversNotified === 0) {
				// The request committed but its receiver definition resolved to no active
				// users — don't claim staff were told when nobody was.
				alertToast('Request recorded. Our team will review it.', 'success', 'Success');
			} else {
				alertToast('Request sent — staff have been notified', 'success', 'Success');
			}
			queryClient.invalidateQueries({ queryKey: userTypeRequestKeys.pending(userId) });
		},
	});
};
